var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-upload"},[_c('div',[_c('image-selector',{model:{value:(_vm.leftIconImage),callback:function ($$v) {_vm.leftIconImage=$$v},expression:"leftIconImage"}}),(!_vm.leftIconImage)?_c('p',{staticClass:"tip-error"},[_vm._v("请上传文字背景图片")]):_vm._e()],1),_c('p',{staticClass:"tip-upload"},[_vm._v("推荐使用45x45像素的.png图片")])])
}
var staticRenderFns = []

export { render, staticRenderFns }